"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Timeline = _interopRequireDefault(require("./Timeline"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Timeline["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/timeline/index.js
// module id = 934
// module chunks = 1